import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseMessageBusService {

  constructor() { }

  dispatchEvent(eventName: string): void {
    window.dispatchEvent(new CustomEvent(eventName));
  }

  dispatchEventWithData(eventName: string, data: any): void {
    window.dispatchEvent(new CustomEvent(eventName, {
        detail: data
      })
    );
  }

}
